import React, { useEffect, useState } from "react";
import { Input } from "antd";
import { loaderReducer } from "../../../components/toolkit/loader";
import { useDispatch } from "react-redux";
import Cookies from "universal-cookie";
import { endPoints } from "../../../utils/endPoints";

const Index = ({ tranId, isRefresh }) => {
  const dispatch = useDispatch();
  const cookies = new Cookies();
  const token = cookies.get("token");
  const [closingAnswer, setClosingAnswer] = useState();

  useEffect(() => {
    const fetchTasks = async () => {
      dispatch(loaderReducer(true));

      try {
        const response = await fetch(
          //   `${process.env.REACT_APP_API}/workOrders/${endPoints.GET_CLOSING_QUESTIONER}/SO43914`,
          `${process.env.REACT_APP_API}/workOrders/${endPoints.GET_CLOSING_QUESTIONER}/${tranId}`,
          {
            headers: {
              "Content-Type": "application/json",
              Authorization: `Bearer ${token}`,
            },
          }
        );
        dispatch(loaderReducer(false));
        const data = await response.json();
        console.log("dataintask----->", data);
        setClosingAnswer(data.data);
      } catch (error) {
        console.error("Error fetching single work order:", error);

        dispatch(loaderReducer(false));
      }
    };

    fetchTasks();
  }, [tranId, isRefresh]);

  return (
    <div>
      <div className="tupdate">Closing Questionnaire :</div>

      {closingAnswer && closingAnswer.length > 0 ? (
        closingAnswer.map((item, index) => (
          <div key={index}>
            <div className="col-lg-12 col-md-12 col-sm-12 sub2head mt-4 w-full">
              {item.question}
            </div>
            <div className="col-lg-10 col-md-8 col-sm-12 position-relative mt-2 ">
              <Input value={item.answer} disabled className="form-control" />
            </div>
          </div>
        ))
      ) : (
        <div className="mt-4 text-muted">No data found</div>
      )}
    </div>
  );
};

export default Index;
